const hydrationComplete = () => {
  delete window.DISPATCH_REGISTER;
};

export default hydrationComplete;
